import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionActions from "@mui/material/AccordionActions";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import DatePicker from "@mui/lab/DatePicker";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import Chip from "@mui/material/Chip";
import { Recorrencia } from "./Recorrencia";
import { PessoaBusca } from "../../PessoaBusca/PessoaBusca";
import { ProfissionalSetor } from "../../ProfissionalSetor/ProfissionalSetor";
import { useSave } from "../useSave";
import { LoadingButton } from "../../../components/Loading";
import { useMessage } from "../../Message/MessageContext";
import LinearProgress from "@mui/material/LinearProgress";

//TODO: For now removed, check how the system behaves and adjust later if needed
const MAX_RECORRENCIA = Infinity;

export const Agendar = ({ onClose, agendamentoId }) => {
  const { setSuccess } = useMessage();

  const {
    save,
    isSaving,
    dataAgendamento,
    setDataAgendamento,
    pessoaBuscaDialog,
    setPessoaBuscaDialog,
    pacientes,
    setorAtendimento,
    setSetorAtendimento,
    profissional,
    setProfissional,
    addPaciente,
    removePaciente,
    isLoading,
    savedItem,
    dtRecorrencias,
    setDtRecorrencias,
    clear,
    profissionalAdicional,
    setProfissionalAdicional,
  } = useSave(agendamentoId);

  const exceededLimit = dtRecorrencias.length > MAX_RECORRENCIA;

  const onSubmit = async (e) => {
    e.preventDefault();
    await save();
  };

  useEffect(() => {
    if (savedItem) {
      setSuccess("Agendamento realizado com sucesso");
      clear();
      onClose(savedItem);
    }
  }, [savedItem]);

  if (isLoading) {
    return (
      <AccordionDetails>
        <LinearProgress />
      </AccordionDetails>
    );
  }

  return (
    <>
      <form onSubmit={onSubmit}>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <DatePicker
                autoOk
                fullWidth
                autoFocus
                ampm={false}
                disablePast
                value={dataAgendamento}
                onChange={setDataAgendamento}
                inputFormat="dd/MM/yyyy HH:mm"
                inputVariant="outlined"
                label="Data e hora"
                renderInput={(p) => <TextField required {...p} fullWidth />}
              />
            </Grid>

            <ProfissionalSetor
              gridSetorProps={{ xs: 12, md: 8 }}
              gridProfissionalProps={{ xs: 12, md: 7 }}
              setorAtendimento={setorAtendimento}
              onChangeSetor={(e, setorAtendimento) => {
                setSetorAtendimento(setorAtendimento);
              }}
              profissional={profissional}
              onChangeProfissional={(e, profissional) => {
                setProfissional(profissional);
              }}
              profissionalAdicional={profissionalAdicional}
              onChangeProfissionaisAdicionais={(e, profissionalAdicional) => {
                setProfissionalAdicional(profissionalAdicional);
              }}
            />

            {!agendamentoId && (
              <Recorrencia
                dtRecorrencias={dtRecorrencias}
                setDtRecorrencias={setDtRecorrencias}
                dataAgendamento={dataAgendamento}
                maxRecorrencias={MAX_RECORRENCIA}
              />
            )}

            <Grid
              item
              xs={12}
              sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
            >
              {pacientes.map((paciente) => (
                <Chip
                  key={paciente.id}
                  label={paciente.nome}
                  variant="outlined"
                  onDelete={() => removePaciente(paciente)}
                />
              ))}
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="outlined"
                size="small"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => setPessoaBuscaDialog(true)}
              >
                Pacientes
              </Button>
            </Grid>
          </Grid>
        </AccordionDetails>
        <AccordionActions>
          <Button
            onClick={() => {
              clear();
              onClose();
            }}
          >
            Cancelar
          </Button>
          <LoadingButton
            disabled={isSaving || exceededLimit}
            variant="contained"
            type="submit"
            loading={isSaving}
          >
            Confirmar
          </LoadingButton>
        </AccordionActions>
      </form>
      <Dialog
        open={pessoaBuscaDialog}
        onClose={() => setPessoaBuscaDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <PessoaBusca
          onSelect={(newPaciente) => addPaciente(newPaciente)}
          onCancel={() => setPessoaBuscaDialog(false)}
          cancelLabel="Concluir"
        />
      </Dialog>
    </>
  );
};
